module.exports = __webpack_public_path__ + "img/logo-url.62164346.png";